<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" fill-rule="evenodd" d="M14 10H6V9h8z" clip-rule="evenodd"/></svg>